import { reduce } from "et3-type-guards";

import Et3CustomizedButton from "../../core/et3-button/Et3CustomizedButton";
import ET3Div from "../../core/et3-div";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import Et3Text from "../../core/et3-text";
import getCorePersonalStore from "../../stores/core/core-personal-store";
import getCoreUIStore from "../../stores/core/core-ui-store";
import SearchBar from "./SearchBar";

const UserName = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const user = getCorePersonalStore().user.get();
  const name = reduce(() => user.username, "");
  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={470}
      height={95}
      fDirection="column"
      alignItems="center"
      justifyContent="center"
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <Et3CustomizedButton
        isEnabled={true}
        withShadow={false}
        width={395}
        height={40}
        fDirection="row"
        alignItems="center"
        justifyContent="center"
        color={colors.all.transparent}
        style={{}}
        onClick={() => getCoreUIStore().toggleProfileDropdown()}
      >
        <Et3Text
          fontFamily={"LIGHT"}
          fontSize={24}
          text={name}
          isSpan={false}
          color={colors.all.maastrichtBlue}
          style={{}}
        />
      </Et3CustomizedButton>
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={395}
        height={55}
        fDirection="row"
        alignItems="center"
        justifyContent="center"
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <SearchBar />
      </ET3Div>
    </ET3Div>
  );
});
export default UserName;
